import React from "react";
import { fileUrl, useFETCH, useFilter } from "../../../Tools/APIs";
import { Col, Container, Row } from "../../../Tools/Grid-system";
import { Button } from "../../../components";
import { useLocation, useParams } from "react-router-dom";
import Pagination from "../../../Tools/Pagination";
import { ContactSection } from "../../../components";
import { BsTelephone } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";

function Area({ filters }) {
  const { handleParamsClick, searchParams, handleParamsDelete } = useFilter();
  const { id } = useParams();
  const { search } = useLocation();
  const { data: areaType } = useFETCH(
    `areas/${id}?local=${localStorage.getItem("language")}`
  );
  const { data, isLoading } = useFETCH(`compounds` + search);
  return (
    <div>
      <div className="flex items-center bg-slate-300 flex-wrap">
        {areaType?.data.data?.property_types.map((e) => (
          <div
            onClick={() => {
              if (
                searchParams.has("property_type") &&
                +searchParams.get("property_type") === e.id
              ) {
                handleParamsDelete("property_type");
              } else {
                handleParamsClick("property_type", e.id);
              }
            }}
            className={`${
              +searchParams.get("property_type") === e.id ? "bg-white" : ""
            } flex items-center justify-center hover:bg-white py-2 px-5 cursor-pointer`}
          >
            <div className="flex justify-center flex-col text-center font-semibold h-full">
              <div>
                <img
                  src={fileUrl + e.icon}
                  alt=""
                  width={40}
                  height={40}
                  className="mx-auto"
                />
              </div>
              <div className="min-h-[24px] ">{e.name}</div>
              <div>{e.total}</div>
            </div>
          </div>
        ))}
      </div>

      <Container>
        <div className="flex items-center bg-slate-300 flex-wrap"></div>
        <Pagination
          pageCount={Math.ceil(
            data?.data.data.total / data?.data.data.per_page
          )}
        >
          <Row>
            {isLoading ? (
              <>
                <LoadingPro />
                <LoadingPro />
                <LoadingPro />
                <LoadingPro />
                <LoadingPro />
                <LoadingPro />
              </>
            ) : (
              data?.data.data.data.map((e) => (
                <Col lg={4} xs={6}>
                  <CompoundsCard
                    id={e.id}
                    NewProperty=""
                    details="asd"
                    dataTypes={e.property_types}
                    title={e.name}
                    address={e.address}
                    houseArea={e.house_area}
                    image={fileUrl + e.main_image?.file}
                    whatsapp={e.whatsapp}
                    phone={e.phone_number}
                    start_price={e.start_price}
                    end_price={e.end_price}
                  />
                </Col>
              ))
            )}
          </Row>
        </Pagination>
      </Container>
      <ContactSection bg={true} />
    </div>
  );
}
export default Area;

const LoadingPro = () => {
  return (
    <Col lg={4} xs={6}>
      <div className="w-full h-[400px]  rounded-2xl p-5 bg-white border">
        <div className="bg-slate-300 animate-pulse w-full h-[220px] rounded-2xl"></div>
        <div className="bg-slate-300 animate-pulse w-2/3 h-6 my-2 "></div>
        <div className="bg-slate-300 animate-pulse w-2/5 h-5 my-2 "></div>
        <div className="flex gap-5">
          <div className="bg-slate-300 animate-pulse w-8 h-8 my-2 rounded-full"></div>
          <div className="bg-slate-300 animate-pulse w-8 h-8 my-2 rounded-full"></div>
          <div className="bg-slate-300 animate-pulse w-8 h-8 my-2 rounded-full"></div>
        </div>
        <div className="bg-slate-300 animate-pulse w-2/5 h-5 my-2 "></div>
      </div>
    </Col>
  );
};

const CompoundsCard = ({
  title,
  start_price,
  end_price,
  image,
  address,
  whatsapp,
  phone,
  id,
  dataTypes,
}) => {
  return (
    <>
      <div
        className={
          "h-ful border bg-white mx-1 relative my-2 p-2 rounded-3xl transition-all hover:-translate-y-2 shadow-md hover:shadow-xl"
        }
      >
        <img src={image} alt="" className="w-full h-1/2 rounded-3xl" />
        <Row className="items-end">
          <Col col={10}>
            <p className="text-xl font-bold mb-1">{title}</p>
            <p className="text-lg text-black/50">{address}</p>
            <div className="py-2 flex items-center px-2 text-sm gap-2">
              {dataTypes?.slice(0, 3).map((e, i) => (
                <>
                  <div className=" flex  items-center !px-0">
                    <p className="font-bold text-Main">{e.total}</p>
                    <p>
                      {e.name} {i + 1 < dataTypes.length ? "|" : ""}
                    </p>
                  </div>
                </>
              ))}
              {dataTypes.length > 3 ? (
                <Col col={3} className="flex  items-center ">
                  <p className="text-sm font-bold text-Main">
                    {dataTypes.length}
                  </p>
                  <p>آخرى |</p>
                </Col>
              ) : (
                ""
              )}
            </div>
            <p className="text-sm font-semibold m">start price {start_price}</p>
            <p className="text-lg font-semibold mb-2">to {end_price}</p>
          </Col>
          <Col col={2} className="my-auto space-y-3">
            <a href={"tel:" + phone}>
              <div className="flex justify-center items-center w-[35px] h-[35px] bg-gray-400 bg-opacity-20 rounded-full shadow-xl hover:bg-slate-300 hover:rounded-full ">
                <BsTelephone color="#062371" size={25} />
              </div>
            </a>
            <a href={"whatsapp://send?phone=" + whatsapp}>
              <div className="flex justify-center items-center w-[35px] h-[35px] bg-gray-400 bg-opacity-20 rounded-full shadow-xl hover:bg-slate-300 hover:rounded-full ">
                <FaWhatsapp color="#062371" size={25} />
              </div>
            </a>
          </Col>
        </Row>
        <Button
          link={
            "/home/compound/" +
            id +
            "?compound_id=" +
            id +
            "&local=" +
            localStorage.getItem("language")
          }
          title="See Details"
        />
      </div>
    </>
  );
};
